(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["29-coffee-worlds"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('worlds-motion-controller')) {
  class WorldsMotionController extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.frame = 0;
      this.off = false;
      this.scenes = [];
      try { this.off = localStorage.getItem('29-worlds-motion') === 'off'; } catch {}
      this.onScroll = () => this.queue();
      this.onResize = () => this.sync();
      this.onPreference = () => this.sync();
      this.onToggle = event => {
        if (!event.target.closest('[data-worlds-motion-toggle]') || this.media.matches) return;
        this.off = !this.off;
        try { localStorage.setItem('29-worlds-motion', this.off ? 'off' : 'on'); } catch {}
        this.sync();
      };
      this.onPointer = event => {
        if (!this.enabled || !this.fine.matches || window.innerWidth < 701 || event.pointerType === 'touch') return;
        const element = event.target.closest('[data-parallax-scene]');
        const scene = this.scenes.find(item => item.element === element);
        if (!scene || !scene.active) return;
        const box = element.getBoundingClientRect();
        this.resetPointers();
        scene.pointer.x = Math.max(-1, Math.min(1, (event.clientX - box.left) / Math.max(1, box.width) * 2 - 1));
        scene.pointer.y = Math.max(-1, Math.min(1, (event.clientY - box.top) / Math.max(1, box.height) * 2 - 1));
        this.queue();
      };
      this.onPointerOut = event => {
        const element = event.target.closest('[data-parallax-scene]');
        if (!element || element.contains(event.relatedTarget)) return;
        this.resetPointers();
        this.queue();
      };
      this.onVisibility = () => {
        if (document.hidden) {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.resetPointers();
          this.scenes.forEach(scene => { scene.element.dataset.depthActive = 'false'; });
        } else this.sync();
      };
      this.onSection = event => this.collect(event.type === 'shopify:section:unload' ? event.target : null);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const scene = this.scenes.find(item => item.element === entry.target);
            if (scene) {
              scene.active = entry.isIntersecting;
              if (!scene.active) {
                scene.pointer = {x: 0, y: 0};
                scene.element.dataset.depthActive = 'false';
              }
            }
          });
          this.queue();
        }, {rootMargin: '160px'});
      }
      this.media.addEventListener('change', this.onPreference);
      this.fine.addEventListener('change', this.onPreference);
      document.addEventListener('click', this.onToggle);
      document.addEventListener('pointermove', this.onPointer, {passive: true});
      document.addEventListener('pointerout', this.onPointerOut, {passive: true});
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:section:load', this.onSection);
      document.addEventListener('shopify:section:unload', this.onSection);
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onResize, {passive: true});
      this.collect();
    }
    collect(excluded) {
      this.observer?.disconnect();
      this.scenes = [...document.querySelectorAll('[data-coffee-worlds] [data-parallax-scene]')]
        .filter(element => !excluded || !excluded.contains(element))
        .map(element => ({element, active: true, pointer: {x: 0, y: 0}, layers: [...element.querySelectorAll('[data-parallax]')].map(layer => ({
          element: layer, speed: Number(layer.dataset.parallax) || 0, pointer: Number(layer.dataset.depthPointer) || 0,
          limit: Number(layer.dataset.depthLimit) || 70, x: 0, y: 0
        }))}));
      this.scenes.forEach(scene => this.observer?.observe(scene.element));
      this.sync();
    }
    resetPointers() { this.scenes.forEach(scene => { scene.pointer = {x: 0, y: 0}; }); }
    queue() {
      if (this.enabled && !document.hidden && !this.frame) this.frame = requestAnimationFrame(() => this.draw());
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.resetPointers();
      this.enabled = !this.off && !this.media.matches;
      document.documentElement.dataset.worldsMotion = this.enabled ? 'on' : 'off';
      document.querySelectorAll('[data-worlds-motion-toggle]').forEach(button => {
        button.hidden = false;
        button.setAttribute('aria-pressed', String(this.enabled));
        button.disabled = this.media.matches;
        button.textContent = this.enabled ? button.dataset.onLabel : button.dataset.offLabel;
      });
      this.draw(true);
    }
    draw(snap = false) {
      this.frame = 0;
      if (document.hidden) return;
      const viewport = window.innerHeight;
      const mobile = window.innerWidth < 701;
      const pointerEnabled = this.fine.matches && !mobile;
      const measurements = this.scenes.map(scene => {
        const box = this.enabled && scene.active ? scene.element.getBoundingClientRect() : null;
        return {scene, box, visible: Boolean(box && box.top < viewport + 160 && box.top + box.height > -160)};
      });
      let moving = false;
      measurements.forEach(({scene, box, visible}) => {
        scene.element.dataset.depthActive = String(this.enabled && visible);
        if (this.enabled && !visible) return;
        const distance = box ? viewport / 2 - box.top - box.height / 2 : 0;
        scene.layers.forEach(layer => {
          const limit = mobile ? Math.min(20, layer.limit * .25) : layer.limit;
          const scroll = distance * layer.speed * (mobile ? .36 : 1);
          const pointerX = pointerEnabled ? scene.pointer.x * layer.pointer : 0;
          const pointerY = pointerEnabled ? scene.pointer.y * layer.pointer * .65 : 0;
          const x = this.enabled ? pointerX : 0;
          const y = this.enabled ? Math.max(-limit, Math.min(limit, scroll + pointerY)) : 0;
          const immediate = snap || !this.enabled;
          layer.x = immediate || Math.abs(x - layer.x) < .08 ? x : layer.x + (x - layer.x) * .16;
          layer.y = immediate || Math.abs(y - layer.y) < .08 ? y : layer.y + (y - layer.y) * .16;
          if (Math.abs(x - layer.x) < .08) layer.x = x;
          if (Math.abs(y - layer.y) < .08) layer.y = y;
          if (Math.abs(x - layer.x) >= .08 || Math.abs(y - layer.y) >= .08) moving = true;
          layer.element.style.setProperty('--parallax-x', layer.x.toFixed(2) + 'px');
          layer.element.style.setProperty('--parallax-y', layer.y.toFixed(2) + 'px');
        });
      });
      if (moving) this.queue();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.media.removeEventListener('change', this.onPreference);
      this.fine.removeEventListener('change', this.onPreference);
      document.removeEventListener('click', this.onToggle);
      document.removeEventListener('pointermove', this.onPointer);
      document.removeEventListener('pointerout', this.onPointerOut);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:section:load', this.onSection);
      document.removeEventListener('shopify:section:unload', this.onSection);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.scenes.forEach(scene => {
        scene.element.dataset.depthActive = 'false';
        scene.layers.forEach(layer => {
          layer.element.style.setProperty('--parallax-x', '0.00px');
          layer.element.style.setProperty('--parallax-y', '0.00px');
        });
      });
    }
  }
  customElements.define('worlds-motion-controller', WorldsMotionController);
  document.body.append(document.createElement('worlds-motion-controller'));
}
if (!customElements.get('worlds-text-reveal-controller')) {
  class WorldsTextRevealController extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.seen = new WeakSet();
      this.animations = new Set();
      this.nodes = [];
      this.onPreference = () => this.sync();
      this.onToggle = event => { if (event.target.closest('[data-worlds-motion-toggle]')) this.sync(); };
      this.onSection = event => this.collect(event.type === 'shopify:section:unload' ? event.target : null);
      this.onVisibility = () => { if (document.hidden) this.stop(); else this.sync(); };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!this.enabled || document.hidden) return;
          entries.forEach(entry => {
            const node = entry.target;
            if (!entry.isIntersecting || this.seen.has(node) || !this.nodes.includes(node)) return;
            this.seen.add(node);
            this.observer.unobserve(node);
            if (typeof node.animate !== 'function') return;
            const animation = node.animate([
              {transform: 'translateY(14px)', opacity: .65},
              {transform: 'translateY(0)', opacity: 1}
            ], {duration: 620, easing: 'cubic-bezier(.22,1,.36,1)', iterations: 1});
            this.animations.add(animation);
            animation.onfinish = () => this.animations.delete(animation);
            animation.oncancel = () => this.animations.delete(animation);
          });
        }, {threshold: .12});
      }
      this.media.addEventListener('change', this.onPreference);
      document.addEventListener('click', this.onToggle);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:section:load', this.onSection);
      document.addEventListener('shopify:section:unload', this.onSection);
      this.collect();
    }
    collect(excluded) {
      this.stop();
      this.observer?.disconnect();
      this.nodes = [...document.querySelectorAll('[data-coffee-worlds] [data-worlds-reveal]')].filter(node => !excluded || !excluded.contains(node));
      this.sync();
    }
    sync() {
      this.enabled = !this.media.matches && document.documentElement.dataset.worldsMotion !== 'off';
      if (!this.enabled || document.hidden) {
        this.stop();
        this.observer?.disconnect();
        return;
      }
      this.nodes.forEach(node => { if (!this.seen.has(node)) this.observer?.observe(node); });
    }
    stop() {
      [...this.animations].forEach(animation => animation.cancel());
      this.animations.clear();
    }
    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.media.removeEventListener('change', this.onPreference);
      document.removeEventListener('click', this.onToggle);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:section:load', this.onSection);
      document.removeEventListener('shopify:section:unload', this.onSection);
    }
  }
  customElements.define('worlds-text-reveal-controller', WorldsTextRevealController);
  document.body.append(document.createElement('worlds-text-reveal-controller'));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["29-home-brewing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('home-brew-guide')) {
  customElements.define('home-brew-guide', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-brew-tab]')];
      this.panels = [...this.querySelectorAll('[data-brew-panel]')];
      this.tablist = this.querySelector('[data-brew-tabs]');
      if (!this.tablist || this.tabs.length !== this.panels.length || !this.tabs.length) return;
      this.tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
      });
      this.onClick = event => {
        const tab = event.target.closest('[data-brew-tab]');
        const index = this.tabs.indexOf(tab);
        if (index < 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(index);
      };
      this.onKey = event => {
        const index = this.tabs.indexOf(event.target.closest('[data-brew-tab]'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === ' ') next = index;
        else return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      };
      this.tablist.addEventListener('click', this.onClick);
      this.tablist.addEventListener('keydown', this.onKey);
      const hashIndex = this.panels.findIndex(panel => '#' + panel.id === location.hash);
      this.select(hashIndex < 0 ? 0 : hashIndex);
    }
    select(index) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[position].hidden = !selected;
      });
    }
    disconnectedCallback() {
      if (!this.tablist) return;
      this.tablist.removeEventListener('click', this.onClick);
      this.tablist.removeEventListener('keydown', this.onKey);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["29-home-ritual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', function(event) {
  const form = event.target.closest('[data-ritual-finder]');
  if (!form) return;
  event.preventDefault();
  const method = form.elements.method.value;
  const taste = form.elements.taste.value;
  const match = method === 'none' ? (taste === 'classic' ? 'drip' : 'drip_pilot') : taste === 'classic' ? 'smith' : taste === 'fruit' && method !== 'espresso' ? 'kenya' : 'pilot';
  const results = form.parentElement.querySelector('[data-ritual-results]');
  results.querySelector('[data-ritual-initial]').hidden = true;
  results.querySelectorAll('[data-ritual-match]').forEach(function(item) { item.hidden = item.dataset.ritualMatch !== match; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
